import { InvoiceStatusResponse } from 'services/tenantManagementService';
import { INVOICE_STATUSES_FETCHING, INVOICE_STATUSES_SET } from './action';
import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';

export const invoiceStatusReducer = (state = new PersistItemsReducer<InvoiceStatusResponse>(), action: PersistItemsActionType<InvoiceStatusResponse> | FetchingActionType): PersistItemsReducer<InvoiceStatusResponse> => {
	switch (action.type) {
		case INVOICE_STATUSES_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case INVOICE_STATUSES_SET:
			const { items } = action as PersistItemsActionType<InvoiceStatusResponse>;

			const itemsMap: { [id: number]: InvoiceStatusResponse } = items.reduce(
                (map: { [id: number]: InvoiceStatusResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
